import React from 'react'
import cntl from 'cntl'

export const heading = (size = 'lg', color = 'primary', classes = '') => {
    const options = {
        lg: 'text-5xl md:text-7xl',
        md: 'text-4xl lg:text-5xl 2xl:text-5xl',
        subtitle:
            'text-xl xl:text-2xl leading-tight font-semibold mt-2 md:mt-3 text-primary dark:text-primary-dark/50',
        sm: 'text-[18px] md:text-[20px] leading-tight md:text-xl font-semibold mt-2 md:mt-3 opacity-75',
    }
    return cntl`
        m-0
        text-center
        ${options[size]}
        text-${color}
        ${classes}
    `
}

export const section = (className = '') => cntl`
    max-w-screen-2xl
    mx-auto
    mt-4
    mb-16
    md:my-16
    px-4
    ${className}
`

export const gradientWrapper = cntl`
    relative
    before:bg-gradient-to-t
    before:from-primary
    before:absolute
    before:w-full
    before:h-1/3
    before:bottom-0
    before:left-0
    before:z-10
`

export const programgoalssection = (className = '') => cntl`
    background: linear-gradient(#24b7ff, #24b7ff);
    padding: 60px 0;
    border-radius: 24px 24px 0 0;

    h3 {
        font-size: 36px;
        color: #1f1f1f;
        margin: 0 0 22px;
    }

    p {
        color: #1f1f1f;
        font-size: 18px;
        margin: 0 0 4px;
    }

    .goals-list {
        margin-top: 36px;
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 24px;

        @media (min-width: 768px) {
            grid-template-columns: 1fr 1fr;
        }
    }

    .goal-item {
        background-color: #fff;
        padding: 18px;
        border-radius: 16px;
    }

    .goal-title {
        color: #00536b;
        margin: 22px;
        font-size: 22px;
    }
`
